(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const storeHeader = document.querySelector('store-header');
 
    if (!storeHeader) return;
 
    const updateLogoAnimation = () => {
      if (window.scrollY > 30) {
        storeHeader.classList.add('logo-is-small');
      } else {
        storeHeader.classList.remove('logo-is-small');
      }
    };
 
    updateLogoAnimation();
    window.addEventListener('scroll', updateLogoAnimation, { passive: true });
        const mobileMenuToggle = document.querySelector('.main-menu__toggle');
    const mobileMainMenu = document.querySelector('main-menu');
 
    if (mobileMenuToggle && mobileMainMenu) {
      mobileMenuToggle.addEventListener('click', () => {
        const drawerItems = mobileMainMenu.querySelectorAll('.main-nav > li');
 
        drawerItems.forEach((item, index) => {
          item.style.animationDelay = `${index * 0.045}s`;
        });
 
        mobileMainMenu.classList.remove('mishuuu-drawer-animate');
        void mobileMainMenu.offsetWidth;
        mobileMainMenu.classList.add('mishuuu-drawer-animate');
      });
    }
 
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-mishuuu-currency-select]');
 
      if (!select) return;
 
      const form = select.closest('form');
 
      if (form) {
        form.submit();
      }
  });
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();
 
        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }
 
      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
 
      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }
 
    customElements.define('nav-menu', NavMenu);
  });
  });

  } catch(e) { console.error(e); }
})();
})();
